export default "/discord.400c9152-b34e72.svg";